// extracted by mini-css-extract-plugin
module.exports = {"main":"Section_main__fXdaV","list":"Section_list__cwBPj","listItem":"Section_listItem___hu4n","listItemCard":"Section_listItemCard__gYUTW"};